module.exports = __webpack_public_path__ + "img/coinspopup-4.f50197db.png";